
define('text!views/shared/list/icon_list.html',[],function () { return '';});

